/** @jsxImportSource @emotion/react */
import React from 'react'

interface RecentsIconProps extends React.HTMLAttributes<HTMLSpanElement> {
  size?: number
  color?: string
}

const RecentsIcon: React.FC<RecentsIconProps> = ({
  size,
  color,
  className,
  style,
  ...rest
}) => {
  return (
    <span className={`anticon ${className || ''}`} style={style} {...rest}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={size ? `${size}px` : '1em'}
        height={size ? `${size}px` : '1em'}
        viewBox='0 0 24 24'
        fill='none'
      >
        <path
          d='M13.404 3.00179C8.31402 2.86179 4.14402 6.94179 4.14402 12.0018H2.35402C1.90402 12.0018 1.68402 12.5418 2.00402 12.8518L4.79402 15.6518C4.99402 15.8518 5.30402 15.8518 5.50402 15.6518L8.29402 12.8518C8.61402 12.5418 8.38402 12.0018 7.94402 12.0018H6.14402C6.14402 8.10179 9.32402 4.95179 13.244 5.00179C16.964 5.05179 20.094 8.18179 20.144 11.9018C20.194 15.8118 17.044 19.0018 13.144 19.0018C11.534 19.0018 10.044 18.4518 8.86402 17.5218C8.46402 17.2118 7.90402 17.2418 7.54402 17.6018C7.12402 18.0318 7.15402 18.7318 7.62402 19.1018C9.14402 20.2918 11.064 21.0018 13.144 21.0018C18.194 21.0018 22.284 16.8318 22.144 11.7418C22.014 7.05179 18.094 3.13179 13.404 3.00179ZM12.894 8.00179C12.484 8.00179 12.144 8.34179 12.144 8.75179V12.4318C12.144 12.7818 12.334 13.1118 12.634 13.2918L15.754 15.1418C16.114 15.3518 16.574 15.2318 16.784 14.8818C16.994 14.5218 16.874 14.0618 16.524 13.8518L13.644 12.1418V8.74179C13.644 8.34179 13.314 8.00179 12.894 8.00179Z'
          fill={color || 'currentColor'}
        />
      </svg>
    </span>
  )
}

export default RecentsIcon
